module.exports = "<tab-login></tab-login>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/component/login/loginIndex.html
// module id = 180
// module chunks = 0